/**
 * @module app/config
 */

import type {NetxThemeStyles} from '@netx/core-components/Theme/types';

export default {
	CSS_CUSTOM_PROPERTY_PREFIX: '--theme-',
	CSS_CUSTOM_PROPERTIES: {
		'light-primary': '#327FEF',
		'light-on-primary': '#ffffff',

		'light-secondary': '#327FEF',
		'light-on-secondary': '#ffffff',

		'dark-primary': '#327FEF',
		'dark-on-primary': '#eee',

		'dark-secondary': '#327FEF',
		'dark-on-secondary': '#eee',
	} as NetxThemeStyles,
	DEFAULT_THEME_MODE: 'light',

	/**
	 * The standard date format that all API calls should return
	 * WARNING: Not all dates have been corrected on the server
	 * @const
	 * @type {string}
	 * @default
	 */
	DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss.SSS',

	// /**
	//  * The DAM (server) version this client instance requires,
	//  * specified in the format of 'semver' -- https://github.com/npm/node-semver
	//  * @const
	//  * @type {string}
	//  * @default
	//  */
	// REQUIRED_SERVER_VERSION: '>=8.12.x', // at least version 8.12
	/**
	 * CSS id of application wrapper
	 * @const
	 * @type {string}
	 * @default
	 */
	CONTAINER_ID: 'wrapper',
	/**
	 * CSS id of login container element
	 * @const
	 * @type {string}
	 * @default
	 */
	LOGIN_CONTAINER_ID: 'login',
	/**
	 * CSS id of alert container element
	 * @const
	 * @type {string}
	 * @default
	 */
	ALERT_CONTAINER_ID: 'alerts',
	/**
	 * CSS id of gallery container element
	 * @const
	 * @type {string}
	 * @default
	 */
	GALLERY_CONTAINER_ID: 'gallery',
	/**
	 * CSS id of tack container element
	 * @const
	 * @type {string}
	 * @default
	 */
	TACK_CONTAINER_ID: 'tack',
	/**
	 * CSS id of header container element
	 * @const
	 * @type {string}
	 * @default
	 */
	HEADER_CONTAINER_ID: 'header',
	/**
	 * CSS id of modal container element
	 * @const
	 * @type {string}
	 * @default
	 */
	MODAL_CONTAINER_ID: 'modal',

	/**
	 * Interval used for polling in milliseconds
	 * @const
	 * @type {number}
	 * @default
	 */
	POLL_INTERVAL: 5000,
	/**
	 * Length of time passive alert will display before fade out
	 * @const
	 * @type {number}
	 * @default
	 */
	PASSIVE_ALERT_DELAY: 1000,
};
